var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 144,
    fill: "#8C8C8C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Voop - screen 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 844,
    transform: "translate(-123 -413)",
    fill: "#181C24"
  }), /*#__PURE__*/React.createElement("g", {
    id: " "
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 71.9953,
    cy: 71.715,
    r: 71.715,
    fill: "#4C46DC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M71.9952 83.1884C75.0384 83.1884 77.9569 81.9796 80.1086 79.8277C82.2604 77.6758 83.4693 74.7574 83.4693 71.7143V56.4155C83.4693 52.3163 81.2825 48.5283 77.7323 46.4784C74.1821 44.4291 69.8084 44.4291 66.2582 46.4784C62.708 48.5283 60.5211 52.3163 60.5211 56.4155V71.7143C60.5211 74.7574 61.7299 77.6759 63.8818 79.8277C66.0337 81.9795 68.9521 83.1884 71.9952 83.1884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M87.294 71.7144C87.294 77.18 84.3781 82.2305 79.6446 84.9631C74.9112 87.6964 69.0793 87.6964 64.3458 84.9631C59.6124 82.2303 56.6964 77.1796 56.6964 71.7144H52.8717C52.8478 76.4717 54.598 81.067 57.7807 84.6036C60.9629 88.1397 65.3494 90.3629 70.0831 90.8384V98.4878H73.9078V90.8384C78.6413 90.3629 83.0278 88.1398 86.2102 84.6036C89.3929 81.0675 91.1431 76.4723 91.1192 71.7144H87.294Z",
    fill: "white"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.635b7d1208061c22b4a1130f1f4570c7.svg";
export { ForwardRef as ReactComponent };